import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import APP_CONSTANTS from '../../config/constants';
import Axios from 'axios';
import { LOCAL_STORAGE } from '../../utils/constants';
const MyState = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)

    let handleSearch = (e, data) => {
        if (data.searchQuery) {
            setloading(true)
            let gett = LOCAL_STORAGE.userToken
            Axios.get(`${APP_CONSTANTS.BASE_URL}/masters/stateMaster?customerNumber=${localStorage.getItem('customerNumber')}&userId=${localStorage.getItem('userId')}`, { headers: { 'Content-Type': 'application/json', 'Authorization': `${gett}` } }).then((response) => {
                if (response.status === 200) {
                    if (response.data.status === 1) {
                        setcontent(response.data.resultSet)
                        setloading(false)
                    }
                }
            })
        }
    }
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.stateId
            temp.text = object.state
            temp.value = object.stateId
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            search
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            onSearchChange={handleSearch}
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyState